import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const conditions = ['Peripheral Neuropathy', 'Diabetic Neuropathy', 'Chemotherapy-Induced Neuropathy', 'Idiopathic Neuropathy', 'Nerve Damage', 'Sciatica & Radiculopathy'];
export function Conditions() {
  return <section className="py-20 bg-muted/30" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1" data-id="element-15">
            <div className="aspect-square md:aspect-[4/3] rounded-2xl overflow-hidden shadow-xl" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/5eNh9bcgANfQiDHo3z2Ak4/core_strengthening_with_a_patient.jpg" alt="A therapist guiding a patient through balance and strengthening exercises" className="object-cover w-full h-full" data-id="element-17" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2 flex flex-col gap-6" data-id="element-18">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground" data-id="element-19">
              Conditions We Treat
            </h2>
            <p className="text-lg text-muted-foreground" data-id="element-20">
              Neuropathy isn't just one condition—it's a complex set of symptoms
              with many underlying causes. We specialize in diagnosing and
              treating various forms of nerve damage.
            </p>

            <ul className="grid sm:grid-cols-2 gap-4 mt-4" data-id="element-21">
              {conditions.map((condition, index) => <li key={index} className="flex items-center gap-3" data-id="element-22">
                  <CheckCircle2 className="w-5 h-5 text-primary flex-shrink-0" data-id="element-23" />
                  <span className="font-medium text-foreground" data-id="element-24">
                    {condition}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}